var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useRef } from 'react';
export var VideoPlayer = function (_a) {
    var show = _a.show, url = _a.url, onCloseModal = _a.onCloseModal, showClose = _a.showClose;
    var isOpened = useRef(false);
    useEffect(function () {
        var bodyElement = document.body;
        if (show) {
            bodyElement.classList.add('o-hidden');
            isOpened.current = true;
        }
        else {
            if (isOpened.current) {
                bodyElement.classList.remove('o-hidden');
                isOpened.current = false;
            }
        }
        return function () {
            bodyElement.classList.remove('o-hidden');
        };
    }, [show]);
    var stopParentClick = function (e) {
        e.stopPropagation();
    };
    var getYTVideoId = function () {
        if (url) {
            var params = new URLSearchParams(new URL(url).search);
            return params.get('v');
        }
        return '';
    };
    var iframeProps = {
        src: "https://www.youtube.com/embed/" + getYTVideoId(),
        frameBorder: '0',
        allow: 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture',
        height: 480,
        width: 720,
    };
    return (React.createElement(React.Fragment, null, show && (React.createElement("div", { className: "modal-background", onClick: function () { return onCloseModal(); } },
        React.createElement("div", { className: "modal-foreground", onClick: stopParentClick },
            !url.includes('youtube') ?
                React.createElement("video", { height: "600px", preload: "metadata", controls: true, autoPlay: true },
                    React.createElement("source", { src: url })) :
                React.createElement("iframe", __assign({}, iframeProps)),
            showClose &&
                React.createElement("div", { className: "close-btn", onClick: function () { return onCloseModal(); } }, "\u00D7"))))));
};
